package com.catbit.opinionpoll.core.extensions

fun <A, B> Map<A, B>.swap() = entries.associate { (key, value) -> value to key }.toMap()